<template></template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "@/lib/store";
import {
  callToCustomerFailedNotification,
  callToRepFailedNotification,
} from "./notifications";

const { mapState } = createNamespacedHelpers("conference");

export default {
  props: ["channel"],
  data() {
    return {
      user: store.get("user"),
      team: store.get("team"),
    };
  },
  computed: mapState(["activity"]),
  created() {
    this.channel.bind("connection.failed", ({ participant }) => {
      if (participant.userId === this.user.id) {
        callToRepFailedNotification({
          phoneNumber: this.activity.from.internationalPhoneNumber,
        }).show();
      } else if (!participant.isGhost) {
        // Customer
        callToCustomerFailedNotification({
          crmName: this.team.crm.name,
        }).show();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// connection-failed.vue?18759dc3